import styled from 'styled-components';
import { Typography } from '@components/common/Typography';
import Container from '@components/common/Container';

export const FaqWrapper = styled.div`
  background: ${({
    theme: {
      colors: {
        primary: { lightest },
      },
    },
  }) => lightest};
`;

export const FaqContainer = styled(Container)`
  padding: 120px 0;
  width: 810px;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding: 80px 0;
    width: 90%;
    max-width: ${({ theme }) => theme.container.md};
  }
`;

export const Title = styled(Typography)`
  font-weight: 400;
  margin-bottom: 16px;
`;

export const Head = styled.div`
  font-weight: 700;
  padding: 32px;
  cursor: pointer;
  position: relative;
  svg {
    position: relative;
    top: 6px;
    display: inline-block;
    height: 24px;
    width: 24px;
    fill: ${({
      theme: {
        colors: {
          primary: { main },
        },
      },
    }) => main};
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    padding-right: 64px;
    svg {
      position: absolute;
      right: 32px;
      top: 32px;
    }
  }
`;

export const Body = styled.div`
  padding: 0 32px 32px 32px;
  margin-bottom: 8px;
  display: none;
  p {
    font-size: 16px;
  }
  p:last-child {
    margin-bottom: 0;
  }
  ul {
    list-style: disc;
    margin-left: 24px;
    margin-bottom: 24px;
  }
  a {
    color: ${({ theme }) => theme.colors.primary.main};
    text-decoration: underline;
  }
`;

export const FaqItem = styled.div<{
  isOpen: boolean;
}>`
  background: ${({
    theme: {
      colors: {
        primary: { lightestMore },
      },
    },
  }) => lightestMore};
  border-radius: 12px;
  margin-bottom: 24px;
  :hover {
    background: ${({
      theme: {
        colors: {
          functional: { white },
        },
      },
    }) => white};
    box-shadow: ${({
      theme: {
        boxShadow: { blue },
      },
    }) => blue};
  }
  &:hover ${Head} {
    color: ${({
      theme: {
        colors: {
          primary: { main },
        },
      },
    }) => main};
  }
  ${({
    isOpen,
    theme: {
      colors: {
        primary: { main },
        functional: { white },
      },
      boxShadow: { blue },
    },
  }) =>
    isOpen &&
    `
    background: ${white};
    box-shadow: ${blue};
    ${Head} {
      color: ${main};
      svg {
        transform: rotate(180deg);
      }
    }
    ${Body} {
      display: block;
    }
  `}
`;
